import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=c680dc4a"
import script from "./ChatList.vue?vue&type=script&lang=js"
export * from "./ChatList.vue?vue&type=script&lang=js"
import style0 from "./ChatList.vue?vue&type=style&index=0&id=c680dc4a&prod&lang=scss"
import style1 from "./ChatList.vue?vue&type=style&index=1&id=c680dc4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports